import { Icon } from '@iconify/react';
import { TicketSummary, YourTickets } from './ticketHome';
import { useAuthUser } from '../../contexts/AuthUserContext';

const Overview = () => {
    const user = useAuthUser();
    
    // Determine title based on user role
    const isHeliosAdmin = user?.role === 'helios_admin' || user?.roles?.includes('helios_admin');
    const isClientAdmin = user?.role === 'client_admin' || user?.roles?.includes('client_admin');
    
    let ticketsTitle = 'Your Tickets'; // Default for client_user
    if (isHeliosAdmin) {
        ticketsTitle = 'Open Tickets';
    } else if (isClientAdmin) {
        ticketsTitle = 'Recent Tickets';
    }
    
    return (
        <div className="tickets-overview-responsive">
            {/* Summary */}
                <div className="flex flex-col items-start gap-3 w-full">
                    <div className="responsive-flex-left">
                        <div className="subheader-textbox">
                            {/* <Icon icon="solar:graph-up-broken" className="responsive-icon-sm text-secondary" /> */}
                            <span className="text-font-primary">Summary</span>
                        </div>
                    </div>
                    <TicketSummary />
                </div>
            {/* Your Tickets */}
            <div className="flex flex-col items-start gap-3 w-full">
                <div className="responsive-flex-left">
                    <div className="subheader-textbox">
                        {/* <Icon icon="streamline:tickets-solid" className="responsive-icon-sm text-secondary text-xl sm:text-2xl" /> */}
                        <span className="text-font-primary">{ticketsTitle}</span>
                    </div>
                </div>
                <YourTickets />
            </div>
        </div>
    );
};

export default Overview; 